var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.116 5.39a3.003 3.003 0 0 0-5.125-2.123l-9.19 9.19a5.004 5.004 0 0 0 7.076 7.076l9.19-9.19a1 1 0 0 1 1.414 1.414l-9.19 9.19a7.004 7.004 0 0 1-9.905-9.904l9.19-9.19a5.003 5.003 0 0 1 7.075 7.074l-9.2 9.19a3.001 3.001 0 0 1-4.244-4.244l8.49-8.48a1 1 0 0 1 1.414 1.415l-8.49 8.48a1.002 1.002 0 0 0 1.416 1.415l9.2-9.19.2-.22c.437-.534.679-1.206.679-1.903"
  })));
};
export default Svg24;